/** Keep in sync with ConnectionControlBar styled breakpoints + BulkConnectionActionsDropdown media queries. */
export const CONNECTION_ACTION_BAR_BP = {
    /** Hide, Unhide, Add to pipeline, Import/Export → More dropdown */
    bigDesktop: 2225,
    /** Remove, Tag → More dropdown */
    smallDesktop: 1825,
    /** Find intros + Add to feed → More dropdown (collapse together; Find intros before Add to feed) */
    mutuals: 1680,
    /** Enrich → More dropdown */
    enrich: 1500,
    /** Add to campaign → More dropdown */
    campaigns: 1400,
    /** Message → More dropdown */
    message: 1320,
} as const;

/** More dropdown order — must match ConnectionControlBar action button order. */
export const CONNECTION_ACTION_MENU_ORDER = [
    'messageProfile',
    'addToCampaign',
    'enrichConnection',
    'bulkScanMutualConnections',
    'customFeed',
    'remove',
    'applyRemove',
    'hide',
    'unhide',
    'addToKanban',
    'import',
    'export',
    'exportHubspot',
] as const;
